
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getSubscriptionDetails",
      resolverType: "query",
      routePath: "/getSubscriptionDetails",
      httpMethod: "POST",
    });
  